'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _Small = require('../elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _Functions = require('../core/Functions');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _UISliderTickMark = require('./internal/UISliderTickMark');

var _UISliderTickMark2 = _interopRequireDefault(_UISliderTickMark);

var _UISliderTrack = require('./internal/UISliderTrack');

var _UIAbstractSlider = require('./abstract/UIAbstractSlider');

var _UIAbstractSlider2 = _interopRequireDefault(_UIAbstractSlider);

var _TabIndex = require('../utils/TabIndex');

var _tshirtSize = require('../utils/propTypes/tshirtSize');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getFirstDefinedValue = function getFirstDefinedValue() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.find(function (val) {
    return val != null;
  });
};

var SLIDER_LABELS = {
  max: 'private-slider__label--max',
  min: 'private-slider__label--min'
};

var UISlider = _react2.default.createClass({
  displayName: 'UISlider',

  propTypes: {
    disabled: _react.PropTypes.bool,
    onChange: _react.PropTypes.func,
    onRawValueChange: _react.PropTypes.func,
    min: _react.PropTypes.number,
    minLabel: _react.PropTypes.node,
    max: _react.PropTypes.number.isRequired,
    maxLabel: _react.PropTypes.node,
    trackStart: _react.PropTypes.number,
    trackEnd: _react.PropTypes.number,
    onKeyDown: _react.PropTypes.func,
    onMouseLeave: _react.PropTypes.func,
    onMouseMove: _react.PropTypes.func,
    onMouseDown: _react.PropTypes.func,
    onMouseUp: _react.PropTypes.func,
    showLabels: _react.PropTypes.bool,
    size: _react.PropTypes.oneOfType([(0, _tshirtSize.propTypeForSizes)(['lg']), _react.PropTypes.oneOf(['default'])]),
    step: _react.PropTypes.number.isRequired,
    showTickMarks: _react.PropTypes.bool,
    value: _react.PropTypes.number,
    readOnly: _react.PropTypes.bool,
    restrictedAreaTooltip: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.func])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      min: 0,
      max: 100,
      step: 1,
      value: null
    };
  },
  getInitialState: function getInitialState() {
    return {
      isDragging: false
    };
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    if (!prevState.isDragging && this.state.isDragging) {
      this.addBodyDragCursorClass();
    } else if (prevState.isDragging && !this.state.isDragging) {
      this.removeBodyDragCursorClass();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.removeBodyDragCursorClass();
  },
  addBodyDragCursorClass: function addBodyDragCursorClass() {
    document.body.classList.add('hubspot-drag-cursor');
  },
  removeBodyDragCursorClass: function removeBodyDragCursorClass() {
    document.body.classList.remove('hubspot-drag-cursor');
  },
  handleChange: function handleChange(rawValue) {
    var _props = this.props,
        disabled = _props.disabled,
        max = _props.max,
        min = _props.min,
        onChange = _props.onChange,
        onRawValueChange = _props.onRawValueChange,
        readOnly = _props.readOnly,
        step = _props.step,
        value = _props.value,
        trackStart = _props.trackStart,
        trackEnd = _props.trackEnd;


    if (disabled || readOnly) {
      return;
    }

    var adjustedRawValue = this.getAdjustedValue(trackStart, trackEnd, step, rawValue);
    (0, _Functions.callIfPossible)(onRawValueChange, (0, _SyntheticEvent2.default)(adjustedRawValue));

    var newValue = this.getAdjustedValue(min, max, step, rawValue);
    if (value !== newValue) {
      onChange((0, _SyntheticEvent2.default)(newValue));
    }
  },
  handleKeyDown: function handleKeyDown(evt) {
    var _props2 = this.props,
        step = _props2.step,
        value = _props2.value;


    var nextValue = value || 0;
    if (evt.key === 'ArrowLeft' || evt.key === 'ArrowDown') {
      evt.preventDefault();
      nextValue = value - step;
    } else if (evt.key === 'ArrowRight' || evt.key === 'ArrowUp') {
      evt.preventDefault();
      nextValue = value + step;
    }

    this.handleChange(nextValue);
    (0, _Functions.callIfPossible)(this.props.onKeyDown, evt);
  },
  handleDrag: function handleDrag(evt) {
    var percentX = evt.target.value.percentX;

    this.handleChange(this.getControlValueFromPercentX(percentX));
  },
  handleDragStart: function handleDragStart() {
    this.setState({ isDragging: true });
  },
  handleDragEnd: function handleDragEnd() {
    this.setState({ isDragging: false });
  },
  handleMinLabelClick: function handleMinLabelClick() {
    var _props3 = this.props,
        disabled = _props3.disabled,
        min = _props3.min,
        readOnly = _props3.readOnly;

    if (!disabled && !readOnly) this.handleChange(min);
  },
  handleMaxLabelClick: function handleMaxLabelClick() {
    var _props4 = this.props,
        disabled = _props4.disabled,
        max = _props4.max,
        readOnly = _props4.readOnly;

    if (!disabled && !readOnly) this.handleChange(max);
  },
  checkPropValidity: function checkPropValidity(_ref) {
    var max = _ref.max,
        min = _ref.min,
        step = _ref.step,
        trackStart = _ref.trackStart,
        trackEnd = _ref.trackEnd;

    if (Math.abs(min % step) !== 0 || Math.abs(max % step) !== 0) {
      _devLogger2.default.warn({
        message: 'UISlider: Min and max value should be a multiple of the step',
        key: 'UISlider: Min or max not a multiple of the step'
      });
    }

    if (trackStart != null && trackStart > min) {
      _devLogger2.default.warn({
        message: 'UISlider: trackStart value should be less than the min',
        key: 'UISlider: trackStart greater than min'
      });
    }

    if (trackEnd != null && trackEnd < max) {
      _devLogger2.default.warn({
        message: 'UISlider: trackEnd value should be greater than the max',
        key: 'UISlider: trackEnd less than max'
      });
    }
  },
  getAdjustedValue: function getAdjustedValue(min, max, step, rawValue) {
    if (rawValue < min) return min;
    if (rawValue > max) return max;
    if (Math.abs(rawValue % step) !== 0) {
      return Math.round(rawValue / step) * step;
    }
    return rawValue;
  },
  getControlValueFromPercentX: function getControlValueFromPercentX(percentX) {
    var min = getFirstDefinedValue(this.props.trackStart, this.props.min, 0);
    var max = getFirstDefinedValue(this.props.trackEnd, this.props.max, 0);
    return percentX * (max - min) + min;
  },
  getControlPositionFromValue: function getControlPositionFromValue(_ref2, adjustedValue) {
    var min = _ref2.min,
        max = _ref2.max;

    if (max - min === 0) {
      return 0;
    }
    return (adjustedValue - min) / (max - min) * 100;
  },
  renderLabel: function renderLabel(longhandSize, value, label, name) {
    var use = longhandSize === 'large' ? null : 'help';
    var calculatedClassName = (0, _classNames2.default)('private-slider__label', SLIDER_LABELS[name], {
      'is--heading-5': longhandSize === 'large'
    });
    return _react2.default.createElement(
      _Small2.default,
      {
        className: calculatedClassName,
        onClick: name === 'min' ? this.handleMinLabelClick : this.handleMaxLabelClick,
        use: use
      },
      label || value
    );
  },
  renderTrackSegment: function renderTrackSegment(_ref3, _ref4) {
    var disabled = _ref3.disabled,
        readOnly = _ref3.readOnly,
        restrictedAreaTooltip = _ref3.restrictedAreaTooltip,
        size = _ref3.size;

    var value = _ref4.value,
        restricted = _ref4.restricted,
        width = _ref4.width,
        left = _ref4.left,
        trackSegmentProps = _objectWithoutProperties(_ref4, ['value', 'restricted', 'width', 'left']);

    if (width <= 0) {
      return null;
    }

    var track = _react2.default.createElement(_UISliderTrack.UISliderTrackSegment, _extends({}, trackSegmentProps, {
      left: left,
      width: width,
      size: size === 'large' ? size : 'medium',
      restricted: restricted,
      disabled: disabled,
      readOnly: readOnly,
      value: value
    }));

    if (restrictedAreaTooltip) {
      var tooltipTitle = typeof restrictedAreaTooltip === 'function' ? restrictedAreaTooltip(value > 0 ? 'upper' : 'lower') : restrictedAreaTooltip;
      return _react2.default.createElement(
        _UITooltip2.default,
        { title: tooltipTitle, placement: 'bottom' },
        track
      );
    }

    return track;
  },
  renderTickMarks: function renderTickMarks(_ref5, _ref6) {
    var showTickMarks = _ref5.showTickMarks,
        min = _ref5.min,
        value = _ref5.value,
        step = _ref5.step;
    var renderedMax = _ref6.renderedMax,
        renderedMin = _ref6.renderedMin;

    if (!showTickMarks) {
      return null;
    }
    var numberOfTickMarks = (renderedMax - renderedMin) / step;
    var tickMarks = [];
    for (var i = 0; i <= numberOfTickMarks; i++) {
      tickMarks.push(_react2.default.createElement(_UISliderTickMark2.default, {
        currentSliderValue: value,
        key: i,
        value: i * step + renderedMin,
        min: min
      }));
    }
    return tickMarks;
  },
  render: function render() {
    var _props5 = this.props,
        className = _props5.className,
        disabled = _props5.disabled,
        min = _props5.min,
        minLabel = _props5.minLabel,
        max = _props5.max,
        maxLabel = _props5.maxLabel,
        trackStart = _props5.trackStart,
        trackEnd = _props5.trackEnd,
        __onChange = _props5.onChange,
        __onRawValueChange = _props5.onRawValueChange,
        readOnly = _props5.readOnly,
        size = _props5.size,
        showLabels = _props5.showLabels,
        showTickMarks = _props5.showTickMarks,
        step = _props5.step,
        tabIndex = _props5.tabIndex,
        value = _props5.value,
        restrictedAreaTooltip = _props5.restrictedAreaTooltip,
        rest = _objectWithoutProperties(_props5, ['className', 'disabled', 'min', 'minLabel', 'max', 'maxLabel', 'trackStart', 'trackEnd', 'onChange', 'onRawValueChange', 'readOnly', 'size', 'showLabels', 'showTickMarks', 'step', 'tabIndex', 'value', 'restrictedAreaTooltip']);

    this.checkPropValidity({ max: max, min: min, step: step, trackStart: trackStart, trackEnd: trackEnd });

    var longhandSize = (0, _tshirtSize.toLonghandSize)(size);
    var computedClassName = (0, _classNames2.default)(className, 'private-slider', {
      'private-slider--disabled': disabled,
      'private-slider--readonly': readOnly,
      'private-slider--dragging': this.state.isDragging,
      'private-slider--large': longhandSize === 'large'
    });

    var adjustedValue = this.getAdjustedValue(min, max, step, value);
    var renderedMin = getFirstDefinedValue(trackStart, min, 0);
    var renderedMax = getFirstDefinedValue(trackEnd, max, 0);
    var trackLength = renderedMax - renderedMin;
    var controlPosition = this.getControlPositionFromValue({ min: renderedMin, max: renderedMax }, adjustedValue);
    var percentRestrictedLower = 0;
    var percentRestrictedUpper = 0;
    var percentFilled = 0;
    var percentAvailable = 0;

    if (trackLength > 0) {
      percentRestrictedLower = (min - renderedMin) / trackLength * 100;
      percentRestrictedUpper = (renderedMax - max) / trackLength * 100;
      percentFilled = controlPosition - percentRestrictedLower;
      percentAvailable = 100 - percentRestrictedUpper - controlPosition;
    }

    return _react2.default.createElement(
      'div',
      _extends({}, rest, {
        'aria-disabled': disabled,
        'aria-readonly': readOnly,
        'aria-valuemax': max,
        'aria-valuemin': min,
        'aria-valuenow': value || 0,
        'aria-valuetext': '' + (value || 0),
        className: computedClassName,
        onKeyDown: this.handleKeyDown,
        role: 'slider',
        tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex)
      }),
      showLabels ? this.renderLabel(longhandSize, renderedMin, minLabel, 'min') : null,
      _react2.default.createElement(
        _UIAbstractSlider2.default,
        {
          className: 'private-slider__slider',
          onDrag: this.handleDrag,
          onDragStart: this.handleDragStart,
          onDragEnd: this.handleDragEnd
        },
        _react2.default.createElement(
          'div',
          { className: 'private-slider__slider-track' },
          _react2.default.createElement(
            'div',
            { className: 'private-slider__tickmarks' },
            this.renderTickMarks({
              showTickMarks: showTickMarks,
              max: max,
              min: min,
              value: value,
              step: step
            }, { renderedMax: renderedMax, renderedMin: renderedMin })
          ),
          this.renderTrackSegment({ disabled: disabled, readOnly: readOnly, restrictedAreaTooltip: restrictedAreaTooltip, size: size }, {
            width: percentRestrictedLower,
            restricted: true,
            value: -1
          }),
          this.renderTrackSegment({ disabled: disabled, readOnly: readOnly, size: size }, {
            left: percentRestrictedLower,
            width: percentFilled,
            value: 0
          }),
          this.renderTrackSegment({ disabled: disabled, readOnly: readOnly, size: size }, {
            left: controlPosition,
            width: percentAvailable,
            value: 1
          }),
          this.renderTrackSegment({ disabled: disabled, readOnly: readOnly, restrictedAreaTooltip: restrictedAreaTooltip, size: size }, {
            left: controlPosition + percentAvailable,
            width: percentRestrictedUpper,
            restricted: true,
            value: 1
          }),
          _react2.default.createElement('div', {
            className: 'private-slider__control',
            style: { left: controlPosition + '%' }
          })
        )
      ),
      showLabels ? this.renderLabel(longhandSize, renderedMax, maxLabel, 'max') : null
    );
  }
});

exports.default = (0, _Controllable2.default)(UISlider);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/input/UISlider.js
// module id = 663
// module chunks = 3 4